import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-customer-data-dialog',
  template: `
    <h2 mat-dialog-title>Cliente Encontrado</h2>
    <mat-dialog-content>
      <p>Foi encontrado um cliente com este documento. Deseja preencher os dados do parceiro com as informações do cliente?</p>
      <div *ngIf="data.customer">
        <p><strong>Nome:</strong> {{data.customer.name}}</p>
        <p><strong>Documento:</strong> {{data.customer.cpf || data.customer.cnpj}}</p>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onNoClick()">Não</button>
      <button mat-raised-button color="primary" (click)="onYesClick()">Sim</button>
    </mat-dialog-actions>
  `,
})
export class CustomerDataDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CustomerDataDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }
} 